'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callApi = undefined;

var _account = require('./account');

Object.keys(_account).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _account[key];
    }
  });
});

var _config = require('../config');

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _sessionAuthorization = require('./session-authorization');

Object.keys(_sessionAuthorization).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sessionAuthorization[key];
    }
  });
});

var _clients = require('./clients');

Object.keys(_clients).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _clients[key];
    }
  });
});

var _client = require('./client');

Object.keys(_client).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _client[key];
    }
  });
});

var _roleManagement = require('./roleManagement');

Object.keys(_roleManagement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _roleManagement[key];
    }
  });
});

var _fields = require('./fields');

Object.keys(_fields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fields[key];
    }
  });
});

var _users = require('./users');

Object.keys(_users).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _users[key];
    }
  });
});

var _pipeline = require('./pipeline');

Object.keys(_pipeline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pipeline[key];
    }
  });
});

var _maps = require('./maps');

Object.keys(_maps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _maps[key];
    }
  });
});

var _jobs = require('./jobs');

Object.keys(_jobs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _jobs[key];
    }
  });
});

var _api = require('./api');

Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _api[key];
    }
  });
});

var _client_incidents = require('./client_incidents');

Object.keys(_client_incidents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _client_incidents[key];
    }
  });
});

var _tasks = require('./tasks');

Object.keys(_tasks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tasks[key];
    }
  });
});

var _reports = require('./reports');

Object.keys(_reports).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _reports[key];
    }
  });
});

var _contacts = require('./contacts');

Object.keys(_contacts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contacts[key];
    }
  });
});

var _features = require('./features');

Object.keys(_features).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _features[key];
    }
  });
});

var _types = require('./types');

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _markers = require('./markers');

Object.keys(_markers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _markers[key];
    }
  });
});

var _posts = require('./posts');

Object.keys(_posts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _posts[key];
    }
  });
});

var _data = require('./data');

Object.keys(_data).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _data[key];
    }
  });
});

var _permissions = require('./permissions');

Object.keys(_permissions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _permissions[key];
    }
  });
});

var _notifications = require('./notifications');

Object.keys(_notifications).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _notifications[key];
    }
  });
});

var _integrations = require('./integrations');

Object.keys(_integrations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _integrations[key];
    }
  });
});

var _upload = require('./upload');

Object.keys(_upload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _upload[key];
    }
  });
});

var _mapCreator = require('./map-creator');

Object.keys(_mapCreator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mapCreator[key];
    }
  });
});

var _canvassingRegion = require('./canvassing-region');

Object.keys(_canvassingRegion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _canvassingRegion[key];
    }
  });
});

var _v = require('./v4');

Object.keys(_v).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _v[key];
    }
  });
});
exports.default = init;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

var config = _interopRequireWildcard(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.callApi = _callApi2.default;
//Start the next version.

//The code that sets callApi Token up.
function init(options) {
  config.setAuthToken(options.token);
  config.setHeaders(options.headers);
  config.setApiUrl(options.url);
  if (options['url_v' + options.version]) {
    config.setApiUrl(options['url_v' + options.version], options.version);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/index.js
// module id = 10
// module chunks = 0